import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    type: 'behavioral',
    list: [],
    isLoading: false,
    tree: {},
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
